import * as React from "react";
import PageInfo from "../../common/PageInfo/PageInfo";
import Subtitle from "../Subtitle/Subtitle";
import * as styles from "./DefaultMapPage.module.scss";

const DefaultMapPage = ({ title, subtitle, pageInfo, isScroll }) => {
  const bgImage = title === 'Real Estate Globally' ? styles.mapImgRealEstateGlobally : styles.mapImgActiveCountries;
  const root = title === 'Real Estate Globally' ? styles.rootBlack : styles.rootBlack;

  return (
    <section className={root}>
      <div className={styles.mapContainer}>
        <div className={bgImage}/>
      </div>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.titleWrapper}>
            <h1 className={styles.title}>{title}</h1>
          </div>
          <div>
          </div>
        </div>
        <PageInfo text={pageInfo}/>
      </div>
      {subtitle && <Subtitle text={subtitle} isScroll={isScroll}/>}
    </section>
  )
};

export default DefaultMapPage;
